import { CreditCardEnum } from '@sola/schema/dotcom/checkout/billingInfo.js';

export const REDIS_TTL_DEFAULT = 1;

export const COOKIE_COMPASSION_DOMAIN = 'compassion.com';
export const COOKIE_NAME_AUTH_USER_SESSION = 'aus';
export const COOKIE_NAME_AUTH_APP = 'aap';

export const COOKIE_NAME_CAMPAIGN = 'CampaignCookie';
export const COOKIE_NAME_CAMPAIGN_LE = 'le';
export const COOKIE_NAME_CHECKOUT = 'chi';
export const COOKIE_NAME_CART = 'cai';
export const COOKIE_NAME_CART_VERSION = 'cav';
export const COOKIE_NAME_CHILDREN_IN_CART = 'cic';
export const COOKIE_NAME_CI_CLIENT = 'ci_client';

export const COOKIE_NAME_HAS_CART = 'hc';
export const COOKIE_NAME_HAS_AUTH = 'ha';
export const COOKIE_NAME_KOUNT = 'kid';
export const COOKIE_NAME_REFERRER_SOURCE_CODE = 'rsc';

export const HEADER_NAME_SUPPORTER = 'x-supporter';

export const SENSITIVE_MASK_CHAR = '●';
export const ENCRYPTED_CARD_ERROR_CODE = '8888';

export const CURRENCY_USD = 'usd';

export const ACCEPTED_CARDS = [
  CreditCardEnum.Amex,
  CreditCardEnum.Discover,
  CreditCardEnum.Mastercard,
  CreditCardEnum.Visa,
];

export const SHARED_NEXTJS_CACHE_POLICY_ID =
  '30a50589-666a-49f0-807e-b32e67b1591a';

export const SHARED_NEXTJS_CACHE_POLICY_ID_WITH_REFERER =
  '612b7414-6d41-4a93-8c0e-74a66d604847';

// TODO: should this come from somewhere else instead of hard-coded?
export const APPLE_PAY_ALLOWED_LIST = [
  'apple-pay-gateway-cert.apple.com',
  'apple-pay-gateway.apple.com',
  'apple-pay-gateway-nc-pod1.apple.com',
  'apple-pay-gateway-nc-pod2.apple.com',
  'apple-pay-gateway-nc-pod3.apple.com',
  'apple-pay-gateway-nc-pod4.apple.com',
  'apple-pay-gateway-nc-pod5.apple.com',
  'apple-pay-gateway-pr-pod1.apple.com',
  'apple-pay-gateway-pr-pod2.apple.com',
  'apple-pay-gateway-pr-pod3.apple.com',
  'apple-pay-gateway-pr-pod4.apple.com',
  'apple-pay-gateway-pr-pod5.apple.com',
];

export const REQUESTS_SERVER_MAX_SECONDS = 30;
export const REQUESTS_CLIENT_MAX_SECONDS = 90;

export type AwsConfig = {
  ACCOUNT: string;
  REGION: string;
  VERSION: string;
  CERT_ARNS: {
    api: Record<string, string>;
    site: Record<string, string>;
  };
  COMPASSION_DEV_BOUNDARY_ARN: string;
  SST_ASSETS_BUCKET_ARN: string;
};

// @TODO: Once WYSIWYG team gets access to supporter AWS, this won't be necessary.
export const AWS_ACCOUNT_IDS = {
  DIGITAL_MARKETING: '979715710822',
  SUPPORTER: '279142125458',
};

export const AWS: AwsConfig = {
  ACCOUNT: AWS_ACCOUNT_IDS.SUPPORTER,
  REGION: 'us-east-2',
  // TODO: Should we continue to pin this version? As it is, we have to remember to update this with SST upgrades
  VERSION: '7.8.0',
  CERT_ARNS: {
    api: {
      devint:
        'arn:aws:acm:us-east-2:279142125458:certificate/f0517ca7-3e77-4789-952b-8abb3aaa5ed6',
      stage:
        'arn:aws:acm:us-east-2:279142125458:certificate/4c99384b-ab15-4b55-95ac-c94983a90293',
      prod: 'arn:aws:acm:us-east-2:279142125458:certificate/a91f3cdc-f585-40a0-86cf-65021b1b9a16',
    },
    site: {
      // Next JS sites (cloudfront) requires the use of global (us-east-1) certs
      devint:
        'arn:aws:acm:us-east-1:279142125458:certificate/940c7faa-1dad-4602-a759-81e9505d25ae',
      stage:
        'arn:aws:acm:us-east-1:279142125458:certificate/1f560409-cb0d-4a17-8f88-4fa851328c29',
      prod: 'arn:aws:acm:us-east-1:279142125458:certificate/302de659-3a8d-4c62-8aed-978c3d04d792',
    },
  },
  COMPASSION_DEV_BOUNDARY_ARN:
    'arn:aws:iam::279142125458:policy/CompassionDevBoundary',
  SST_ASSETS_BUCKET_ARN: 'arn:aws:s3:::sst-asset-bdoeuboxexvc',
};

export const AWS_DIGITAL: AwsConfig = {
  ACCOUNT: AWS_ACCOUNT_IDS.DIGITAL_MARKETING,
  REGION: 'us-east-2',
  VERSION: '6.66.2',
  CERT_ARNS: {
    api: {},
    site: {},
  },
  COMPASSION_DEV_BOUNDARY_ARN:
    'arn:aws:iam::979715710822:policy/CompassionDevBoundary',
  // TODO: Add correct ARN
  SST_ASSETS_BUCKET_ARN: '',
};
